import styled from 'styled-components';

import { Text } from '../../cdl/Text/Text';
import { theme } from '../../common/ui/theme';

export const TextWithExternalLink = styled(Text).attrs({
    variant: 'small',
    as: 'p',
})`
    a {
        color: ${theme.colors.accent.foreground};

        &:hover,
        &:visited {
            color: ${theme.colors.accent.foreground};
            text-decoration: none;
        }
    }
`;
